<label>Fitters Assigned</label>

<div class='fitterChips'>
  @if (this.assignments.length === 0) {
    <span class='text-muted'>No fitters assigned yet</span>
  }
  @for (assignment of this.assignments; track assignment.id) {
    <div class='fitterChip'>
      <span class='fitterName'>{{ assignment.fitter.firstName }} {{ assignment.fitter.lastName }}</span>
      <span class='fitterDate'>{{ this.formatDate(assignment.scheduledDate) }}</span>
      <input type='number' min='0' step='0.25' class='fitterHoursInput' placeholder='Hours'
        [(ngModel)]='assignment.hours' (change)='this.updateHours(assignment)'>
      <button type='button' class='fitterRemove' (click)='this.removeFitter(assignment)' aria-label='Remove'>&times;</button>
    </div>
  }
</div>

<div class='form-row addFitterRow'>
  <div class="form-group col-md-5">
    <ng-select [(ngModel)]="this.newFitterId" class='form-control' (change)='this.newFitterId = +$event'>
      @for (item of this.fitters; track item) {
        <ng-option [value]='item.id'>{{ item.firstName }} {{ item.lastName }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-3">
    <input type='date' name='scheduledDate' [(ngModel)]='this.newScheduledDate' class="form-control">
  </div>
  <div class="form-group col-md-4">
    <button type='button' class='btn btn-secondary' (click)='this.addFitter()'><i class="fas fa-plus"></i> Add Fitter</button>
  </div>
</div>
